import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { formatIDR, formatIDRCompact } from '../lib/format';

export const KpiCard = ({ label, value, hint, tone = 'default', icon: Icon, compact = false, testid }) => {
  const toneMap = {
    default: 'bg-white/5 border-white/10',
    primary: 'bg-primary/10 border-primary/30',
    accent: 'bg-accent/10 border-accent/30',
    warn: 'bg-orange-500/10 border-orange-500/30',
    danger: 'bg-red-500/10 border-red-500/30',
  };
  return (
    <Card
      data-testid={testid}
      className="rounded-[var(--radius)] bg-card border border-border shadow-[0_10px_30px_-20px_rgba(0,0,0,0.8)] hover:border-white/20 transition-colors"
    >
      <CardContent className="p-4 md:p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="text-xs font-medium text-muted-foreground">{label}</div>
          {Icon ? (
            <div className={`h-9 w-9 rounded-xl ${toneMap[tone]} flex items-center justify-center`}>
              <Icon className="h-4 w-4" />
            </div>
          ) : null}
        </div>
        <div
          data-testid={testid ? `${testid}-value` : undefined}
          className="mt-2 text-xl md:text-2xl font-semibold tracking-tight font-heading"
        >
          {typeof value === 'number' ? (compact ? formatIDRCompact(value) : formatIDR(value)) : value}
        </div>
        {hint ? <div className="mt-1 text-xs text-muted-foreground">{hint}</div> : null}
      </CardContent>
    </Card>
  );
};
